module.exports = __webpack_public_path__ + "img/pagarMpesa.b6f256da.png";